import { colors } from '../../../../../packages';

export const sx = {
  drawer: {
    '& .MuiDrawer-paper': {
      width: '480px !important',
      boxSizing: 'border-box !important',
    },
  },
  wrapper: {
    display: 'flex !important',
    flexDirection: 'column !important',
    height: '100% !important',
    overflowY: 'hidden !important',
  },
  header: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
    padding: '24px !important',
    borderBottom: `1px solid ${colors.neutral100} !important`,
  },
  headerTitle: {
    fontSize: '20px !important',
    fontWeight: '600 !important',
  },
  backBtn: {
    padding: '0 !important',
  },
  form: {
    height: 'calc(100vh - 75px) !important',
    '& form': {
      flex: '1 !important',
      display: 'flex !important',
      flexDirection: 'column !important',
      height: '100% !important',
    },
  },
  formContent: {
    flex: '1 !important',
    padding: '24px !important',
    overflowY: 'auto !important',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px !important',
    marginBottom: '24px !important',
  },
  sectionTitle: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
  },
  valuesInput: {
    marginBottom: '8px !important',
  },
  objectiveItem: {
    display: 'flex !important',
    alignItems: 'center !important',
  },
  removeObjective: {
    marginLeft: '8px !important',
    padding: '0 !important',
  },
  addObjective: {
    fontSize: '14px !important',
    color: `${colors.primary500} !important`,
    '& svg': {
      width: '18px !important',
      marginRight: '6px !important',
    },
  },
  addGoal: {
    fontSize: '14px !important',
    color: `${colors.primary500} !important`,
    marginBottom: '24px !important',
    '& svg': {
      width: '18px !important',
      marginRight: '6px !important',
    },
  },
  removeContentBtn: {
    fontSize: '14px !important',
    color: `${colors.destructive500} !important`,
    '& svg': {
      width: '18px !important',
      marginRight: '6px !important',
      '& path': {
        fill: colors.destructive500,
      },
    },
  },
  footer: {
    display: 'flex !important',
    justifyContent: 'space-between !important',
    padding: '24px !important',
    borderTop: `1px solid ${colors.neutral100} !important`,
  },
  footerRight: {
    display: 'flex !important',
    gap: '16px !important',
  },
};
